import defaultTheme from "../theme";
// tslint:disable-next-line
// @ts-ignore
export default function getTheme(theme) {
    return theme && theme.colors ? theme : defaultTheme;
}
//# sourceMappingURL=getTheme.js.map